/*
 * Copyright(C) 2018, xplo.re IT Services, Michael Maier.
 * All rights reserved.
 */

window.application = (function () {
    "use strict";

    var app = {};
    app.extendWith = $.extend.bind(app);

    app.extendWith({
        // Default duration for fade-in and fade-out animations.
        fadeDuration: 300,

        cookieConsent: function (path) {
            cookieconsent.initialise({
                cookie: {
                    name: "cookieConsent",
                    path: path,
                    expiryDays: 730,
                    secure: false
                },
                content: {
                    header: "Cookies-Verwendung auf unserer Webseite",
                    message: "Wir verwenden Cookies, um Ihnen ein bestmögliches Nutzererlebnis zu ermöglichen.",
                    dismiss: "Einverstanden",
                    allow: "Cookies zulassen",
                    deny: "Ablehnen",
                    link: "Weitere Informationen",
                    href: path + "privacy",
                    close: "&#x274c;",
                    policy: "Cookie-Regelung",
                    target: null
                },
                layout: "basic",
                position: "bottom",
                theme: "edgeless",
                revokable: false,
                autoOpen: true,
                law: {
                    countryCode: "DE"
                }
            });
        },

        // Non-strict array search (-1 if not found).
        inArray: function (value, array) {
            var i = 0;
            var length = array.length;

            for (; i < length; ++i) {
                // noinspection EqualityComparisonWithCoercionJS
                if (array[i] == value) {
                    return i;
                }
            }

            return -1;
        },

        isDefined: function (value) {
            return typeof value !== typeof undefined;
        },

        initialize: function () {
            app.initializeBasketHooks();
            app.initializeDataDisplayControl();
            app.initializeDataSubmit();
            app.initializeGoToHash();
        },

        initializeDataDisplayControl: function () {
            $("*[data-display-control]").each(function () {
                var node = $(this);
                // Required attribute with selector for control to observe.
                var controlSelector = node.data("display-control");
                var control = $(controlSelector);
                // Optional selector for value, otherwise control value is used.
                var valueSelector = node.data("display-value-selector");
                // Optional delay in ms. If < 30, it is multiplied by the
                // default fade-in and fade-out animation length.
                var delay = node.data("display-delay");
                // Duration in ms to fade out nodes.
                var fadeOutDuration = node.data("display-fade-out-duration");
                // All of the following conditions must be met, if defined. If
                // none is given, the connected node is shown if the value
                // returned evaluates to true.
                //
                // Accepted set of values (array).
                var values = node.data("display-values");
                // Minimum value.
                var minValue = node.data("display-min-value");

                if (app.isDefined(delay)) {
                    delay = parseInt(delay);

                    if (delay < 30) {
                        delay = delay * app.fadeDuration + 20;
                    }
                }

                if (app.isDefined(fadeOutDuration)) {
                    fadeOutDuration = parseInt(fadeOutDuration);
                }
                else {
                    fadeOutDuration = app.fadeDuration;
                }

                if (app.isDefined(values) && !$.isArray(values)) {
                    values = [values];
                }

                if (app.isDefined(minValue)) {
                    minValue = parseFloat(minValue);
                }

                var controlValueInRange = function () {
                    var currentValue;
                    var controlType = control.attr("type");

                    if (valueSelector) {
                        currentValue = $(valueSelector).val();
                    }
                    else if (controlType === "radio" || controlType === "checkbox") {
                        currentValue = $(controlSelector + ":checked").val();
                    }
                    else {
                        currentValue = control.val();
                    }

                    var returnValue = !!currentValue;

                    if (app.isDefined(values)) {
                        returnValue = returnValue &&
                            app.inArray(currentValue, values) > -1;
                    }

                    if (app.isDefined(minValue)) {
                        returnValue = returnValue &&
                            parseFloat(currentValue) >= minValue;
                    }

                    return returnValue;
                };

                var callback = function () {
                    if (controlValueInRange()) {
                        if (node.is(":hidden")) {
                            node.fadeIn({ duration: app.fadeDuration });
                        }
                    }
                    else {
                        if (node.is(":visible")) {
                            if (!fadeOutDuration) {
                                node.hide();
                            }
                            else {
                                node.fadeOut({ duration: app.fadeOutDuration });
                            }
                        }
                    }
                };

                if (delay) {
                    control.change(function () {
                        window.setTimeout(callback, delay);
                    });
                }
                else {
                    control.change(callback);
                }

                if (!controlValueInRange()) {
                    node.hide();
                }
            });
        },

        initializeDataSubmit: function () {
            // Extends links to allow form submission.
            $("a[data-submit='form']").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).parent("form").submit();
            });
        },

        initializeBasketHooks: function () {
            $("*[data-basket-delete-item]").each(function () {
                $(this).click(function () {
                    var $this = $(this),
                        basketID = $this.data("basket-delete-item"),
                        confirmationMessage = $this.data("confirmation-message");

                    if (confirmationMessage &&
                        !window.confirm(confirmationMessage)) {
                        return;
                    }

                    // Add deletion ID to form and submit whole form to keep other basket changes.
                    var form = $(this).parents("form");

                    form.append('<input type="hidden" name="delete[' + basketID + ']" value="1" />');
                    form.submit();
                });
            });
        },

        initializeGoToHash: function () {
            var hash = window.location.hash;

            if (hash) {
                var targetID = decodeURIComponent(hash);

                if (/[a-zA-Z0-9_]+/.test(targetID)) {
                    var target = $(targetID);

                    if (target.length) {
                        $("html, body").stop().animate({
                            "scrollTop": Math.max(0, target.offset().top - $("#js-header").outerHeight() - 40)
                        }, 800);
                    }
                }
            }
        }
    });

    // Run initialisation when DOM is ready.
    $(document).ready(app.initialize);

    return app;
}());